// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'hand';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M8.325 3.31V1.74a1.178 1.178 0 0 1 2.355 0v1.57' />
    <path d='M10.678 7.8V3.31a1.178 1.178 0 1 1 2.354 0v2.354m-7.166 9.812A51.155 51.155 0 0 1 2.67 7.92a1.218 1.218 0 0 1 .712-1.5 1.221 1.221 0 0 1 1.474.462c.462.7.617 1.135 1.05 1.883l.063-5.458a1.177 1.177 0 1 1 2.354 0V7.8' />
    <path d='M13.032 7.8V5.664a1.177 1.177 0 1 1 2.355 0v7.849a3.913 3.913 0 0 1-.785 2.355M5.66 8.325l.687 1.252a2.186 2.186 0 0 1 1.875 1.974' />
    <path d='M5.473 17.437v-1.57h9.418v1.57' />
  </g>
);

export const viewBox = '0 0 18 18';
